import { useState, type FormEvent } from 'react'
import { Link, Navigate } from 'react-router-dom'
import { useAuth } from '../AuthProvider'
import { api } from '../api'
import { Button } from '../../components/ui/Button'

export function ClientForgotPasswordPage() {
  const { isAuthenticated } = useAuth()
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [info, setInfo] = useState('')
  const [busy, setBusy] = useState(false)

  if (isAuthenticated) {
    return <Navigate to="/app" replace />
  }

  async function onSubmit(e: FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError('')
    setInfo('')
    try {
      const res = await api.forgotPassword(email.trim())
      setInfo(res.message || 'If an account exists for that email, a reset link has been sent.')
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Request failed')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="cp-auth">
      <form className="cp-auth__card" onSubmit={(e) => void onSubmit(e)}>
        <p className="cp-eyebrow">Client Panel</p>
        <h1>Forgot password</h1>
        <p className="cp-muted">We will email a secure reset link if an account exists.</p>
        {error ? <p className="cp-error">{error}</p> : null}
        {info ? <p className="cp-ok">{info}</p> : null}
        <label className="cp-field">
          Email
          <input
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>
        <Button type="submit" disabled={busy}>
          {busy ? 'Sending…' : 'Send reset link'}
        </Button>
        <p className="cp-muted">
          <Link to="/app/login">Back to sign in</Link>
        </p>
      </form>
    </div>
  )
}
